// Core
import React from "react";
import { connect } from "react-redux";
import { compose } from 'redux';
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";
import Dialog from "material-ui/Dialog";
import AddPhoto from "material-ui/svg-icons/image/add-a-photo";
import AddSignature from "material-ui/svg-icons/image/broken-image";
import { get } from "lodash";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

// Components
import Spinner from "../../components/spiner/Spinner";
import RichTextEditor from "../../components/RichTextEditor";
import ChecklistUploader from "./ChecklistUploader";
import ChecklistProjectSelect from "../projects/ProjectSelect";
import ShareChecklistDialog from "./ShareChecklistDialog";

// Selectors
import * as checklistsSelectors from "../../redux/checklists/selectors";
import * as projectSelectors from '../../redux/projects/selectors'
import * as checklistSelectors from '../../redux/checklists/selectors'

// Instruments
import { FileStackClient } from "../../services/FileStackService";

import './ChecklistCreator.css';
import ShareIcon from "material-ui/svg-icons/social/share";
import DownloadIcon from "material-ui/svg-icons/file/file-download";

const MAX_DESCRIPTION_TEXT_LENGTH = 2000;

// TODO: move RichTextEditor state to Redux
// and move logic to RichTextEditor component
const stringToEditorObj = (str = '') => {
  const blocksFromHtml = htmlToDraft(str);
  const { contentBlocks, entityMap } = blocksFromHtml;
  const contentState = ContentState.createFromBlockArray(
    contentBlocks,
    entityMap
  );
  const editorState = EditorState.createWithContent(contentState);
  return editorState;
};

const mapStateToProps = state => ({
  isChanged: checklistsSelectors.isChanged(state),
  isProjectOwner: checklistsSelectors.isProjectOwner(state),
  projectsList: projectSelectors.projectsList(state),
  checklistProjectId: checklistSelectors.checklistProjectId(state),
  project: projectSelectors.projectDetails(state)
});

const initialState = {
  title: '',
  group: '',
  // text: '',
  logoUrl: '',
  isOpen: false,
  editorState: stringToEditorObj(),
  textLength: 0,
};

class ChecklistCreator extends React.Component {
  state = { ...initialState };

  _handleUpload = (type) => {
    FileStackClient.picker({
      maxFiles: 1,
      fromSources: [
        "local_file_system",
        "googledrive",
        "dropbox",
        "gmail",
        "box",
        "onedrive",
        "clouddrive"
      ],
      onUploadDone: (res) => {
        const { filesUploaded } = res;
        const { handle } = filesUploaded[0];
        this.setState({ [type]: handle });
      }
    }).open();
  };

  componentWillReceiveProps({ activeChecklist, project, checklistProjectId }) {
    if (activeChecklist) {
      this.setState({
        title: activeChecklist.title,
        logoUrl: activeChecklist.logoUrl,
        group: activeChecklist.group,
        editorState: stringToEditorObj(activeChecklist.text)
      });
    }

    if (project) {
      if (project.id !== get(this.props, 'project.id')) {
        const logoUrl = get(project, 'companyLogo');

        this.setState({logoUrl})

      }
    }

    if (checklistProjectId && checklistProjectId === 'PRIVATE') {
      this.setState({logoUrl: ''})
    }
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  handleChangeEditorState = editorState => {
    const rawState = convertToRaw(editorState.getCurrentContent());
    const textLength = rawState.blocks.reduce((acc, { text }) => acc + text, '').length;

    this.setState({ editorState, textLength })
  };

  handleUploadLogo = () => this._handleUpload('logoUrl');
  handleDeleteLogo = () => this.setState({ logoUrl: '' });

  onAdd = () => {
    const { onAddNewList } = this.props;
    const { title, editorState, logoUrl, group } = this.state;

    const text = draftToHtml(convertToRaw(editorState.getCurrentContent())) + '';

    onAddNewList({ title, text, logoUrl, group });
    this.onClose();
  };

  onClose = () => {
    this.props.onClose();
    this.setState({ ...initialState });
  };

  onEdit = () => {
    const { onEdit, activeChecklist: { id } } = this.props;
    const { title, editorState, logoUrl, group } = this.state;

    const text = draftToHtml(convertToRaw(editorState.getCurrentContent())) + '';

    onEdit(id, { title, text, logoUrl, group });
    this.onClose();
  };

  render() {
    const { title, logoUrl, editorState, isOpen, textLength, group } = this.state;
    const { activeChecklist, isChanged, isProjectOwner, onShareChecklist, initiateShareMode, history, downloadChecklists, checklistProjectId } = this.props;

    const onConfirm = !!activeChecklist ? this.onEdit : this.onAdd;
    const modalTitle = !!activeChecklist ? "Done" : "Add";

    let isCrudOpen = false;
    let isShareOpen = false;

    if (activeChecklist) {
      if (!activeChecklist.IS_SHARE) {
        isCrudOpen = true;
      } else {
        isShareOpen = true;
      }
    }

    return (
      <React.Fragment>
        {isChanged && (
          <div
            style={{
              position: "fixed",
              top: 22,
              right: 300,
              zIndex: 1300
            }}
          >
            <Spinner />
          </div>
        )}
        <Dialog
          onClose={this.onClose}
          open={isOpen || isCrudOpen}
          className="checklistDialog"
        >
          {/* <div style={{ maxHeight: 760, width: '100%', overflowY: 'auto' }}> */}
          <div style={{ textAlign: "center" }}>{modalTitle} checklist</div>
          <TextField
            underlineFocusStyle={{ borderColor: "#6da92e" }}
            fullWidth
            name="group"
            type="text"
            onChange={this.handleChange}
            value={group}
            placeholder="Checklist folder (optional) - Add folders if you use many checklists to ease mobile view of lists"
          />
          <TextField
            underlineFocusStyle={{ borderColor: "#6da92e" }}
            fullWidth
            name="title"
            type="text"
            onChange={this.handleChange}
            value={title}
            placeholder="Checklist title"
          />
          <div style={{ marginTop: '15px' }} />
          <RichTextEditor
            editorState={editorState}
            handleChangeEditorState={this.handleChangeEditorState}
            // onUpload={uploadImage}
            // onSave={this.onSave}
            // text={text}
          />
          <div style={{ marginBottom: '15px', color: 'black' }}>
            Characters: {textLength}
          </div>
          {logoUrl
            ? <div style={{ display: "flex", flexDirection: 'column', alignItems: "center" }}>
                <img
                  src={`https://cdn.filestackcontent.com/${logoUrl}`}
                  alt="logo"
                  style={{
                    width: "300px",
                    height: "300px",
                    objectFit: "contain",
                    overflow: "hidden"
                  }}
                />
                <FlatButton
                  onClick={this.handleDeleteLogo}
                  label="Delete Logo"
                />
              </div>
            :
            <div style={{ display: "flex", flexDirection: 'column', alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", width: '300px', justifyContent: 'space-between' }}>
                    <AddPhoto />
                    <div style={{ width: '270px'}}>
                      <FlatButton
                        onClick={this.handleUploadLogo}
                        label="Upload Logo (optional)"
                        fullWidth
                      />
                    </div>
                  </div>
              </div>
          }
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <FlatButton label="Cancel" onClick={this.onClose} />
            <FlatButton label={modalTitle} onClick={onConfirm} />
          </div>
          {/* </div> */}
        </Dialog>
        <ShareChecklistDialog
          isOpen={isShareOpen}
          onClose={this.onClose}
          activeChecklist={activeChecklist}
          onShare={onShareChecklist}

        />
        <ChecklistProjectSelect history={history} />

        {checklistProjectId && <FlatButton
            label={
              <DownloadIcon style={{marginTop: 7,  color:  this.props.isSharingMode ? "#d3d3d3" : "6da92e"}} />
            }
            onClick={downloadChecklists}
            style={{
              // marginBottom: "25px",
              position: "fixed",
              top: 20,
              right: 350,
              zIndex: 1300,
              backgroundColor: this.props.isSharingMode ? '#6da92e' : '#fff'

            }}
        />}

        {isProjectOwner && <FlatButton
          label="add new Checklist"
          onClick={() => {
            this.setState({ isOpen: true });
          }}
          labelStyle={{ color: "#fff" }}
          hoverColor={"#77c723"}
          backgroundColor={"#6da92e"}
          style={{
            marginBottom: "25px",
            position: "fixed",
            top: 20,
            right: 50,
            zIndex: 1300
          }}
        />}
        {isProjectOwner && <ChecklistUploader />}
          <FlatButton
              label={
                <ShareIcon style={{marginTop: 7,  color:  this.props.isSharingMode ? "#d3d3d3" : "6da92e"}} />
              }
              onClick={initiateShareMode}
              style={{
                // marginBottom: "25px",
                position: "fixed",
                top: 20,
                right: 290,
                zIndex: 1300,
                backgroundColor: this.props.isSharingMode ? '#6da92e' : '#fff'

              }}
          />
      </React.Fragment>
    );
  }
}

const enchance = compose(
  connect(mapStateToProps),
);

export default enchance(ChecklistCreator);
